import { ColumnDef } from '@tanstack/react-table'
import AdvanceTable from 'components/base/AdvanceTable'
import { Link } from 'react-router-dom'
import AdvanceTableFooter from 'components/base/AdvanceTableFooter'
import AdvanceTableProvider from 'providers/AdvanceTableProvider'
import useAdvanceTable from 'hooks/useAdvanceTable'

import { useEffect, useState } from 'react'

// import apiRequest from 'apiRequest'
// import toast, { toastConfig } from 'react-simple-toasts'

export type Customer = {
  id: string
  name: string
  vat_number: string
  phone: string
  currency: string
  address: string
  last_seen: string
  default_language: string
  last_order?: string
}

const customersTablecolumns: ColumnDef<Customer>[] = [
  {
    accessorKey: 'name',
    header: 'Customer',
    cell: ({ row: { original } }) => {
      const { name, id } = original
      return (
        <Link
          to={'/module/clients/client/' + id}
          className="d-flex align-items-center text-body-emphasis"
        >
          <p className="mb-0 fw-bold">{name}</p>
        </Link>
      )
    },
    meta: {
      headerProps: { style: { width: '10%' }, className: 'pe-5 ps-0' },
      cellProps: { className: 'py-0 pe-5 ps-0 white-space-nowrap' }
    }
  },
  {
    accessorKey: 'vat_number',
    header: 'VAT Number',
    meta: {
      headerProps: { style: { width: '20%' }, className: 'pe-5 ps-1' },
      cellProps: { className: 'pe-5 ps-1' }
    }
  },
  {
    accessorKey: 'phone',
    header: 'Phone',
    meta: {
      headerProps: { style: { width: '10%' }, className: 'text-end px-1' },
      cellProps: { className: 'fw-semibold text-body-highlight text-end px-1' }
    }
  },
  {
    accessorKey: 'currency',
    header: 'Currency',
    meta: {
      headerProps: { style: { width: '10%' }, className: 'text-end ps-3 pe-1' },
      cellProps: { className: 'fw-bold text-body-emphasis ps-3 text-end pe-1' }
    }
  },
  {
    accessorKey: 'address',
    header: 'Address',
    meta: {
      headerProps: { style: { width: '25%' }, className: 'ps-7' },
      cellProps: { className: 'ps-7 text-body-highlight white-space-nowrap' }
    }
  },
  {
    accessorKey: 'last_seen',
    header: 'Last seen',
    meta: {
      headerProps: { style: { width: '15%' }, className: 'text-end px-1' },
      cellProps: { className: 'text-body-tertiary text-end px-1' }
    }
  },
  {
    accessorKey: 'default_language',
    header: 'Language',
    meta: {
      headerProps: { style: { width: '15%' }, className: 'text-end px-1' },
      cellProps: { className: 'text-body-tertiary text-end px-1' }
    }
  },
  {
    accessorKey: 'last_order',
    header: 'Last order',
    meta: {
      headerProps: {
        style: { width: '10%', minWidth: 150 },
        className: 'text-end'
      },
      cellProps: { className: 'text-body-tertiary text-end pe-0' }
    }
  }
]

const ClientsTable = (props: {
  updateTable: boolean
  setUpdateTable: () => void
}) => {
  const [customers] = useState<Customer[]>([])
  const [preloader] = useState(false)

  useEffect(() => {
    //   const API_REQUEST = new apiRequest(
    //     'https://demo.globalcloudmedia.com/client/get',
    //     true
    //   )
    //   API_REQUEST.send(
    //     {
    //       limit: 25,
    //       page: 0
    //     },
    //     (data: { status: string; message: string; data: Customer[] }) => {
    //       if (data.status == 'success') {
    //         setCustomers(data.data)
    //       } else {
    //         toastConfig({
    //           position: 'top-right',
    //           duration: 2000,
    //           theme: 'light'
    //         })
    //         toast(data.message)
    //       }
    //       setPreloader(false)
    //       props.setUpdateTable()
    //     }
    //   )
  }, [props.updateTable])

  const table = useAdvanceTable({
    data: customers,
    columns: customersTablecolumns,
    selection: true,
    sortable: true
  })

  return (
    <div>
      <AdvanceTableProvider {...table}>
        <AdvanceTable
          tableProps={{ className: 'phoenix-table fs-9' }}
          preloader={preloader}
        />
        <AdvanceTableFooter pagination />
      </AdvanceTableProvider>
    </div>
  )
}

export default ClientsTable
